export const GLOBAL_LOADING = "GLOBAL_LOADING";

export const setGlobalLoading = (loading) => ({
  type: GLOBAL_LOADING,
  payload: loading,
});
